import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { TYPES } from '@Types';
import { container } from '@Container';
import { Dispatch } from '@Redux/type';
import { ArsenalUnitView } from '@Selectors/arsenal/make/view/ArsenalUnitView';
import { ArsenalUnitAction } from '@Redux/actions';
import { UnitRow } from './ArsenalUnitRow.styled';
import ArsenalUnitEdit from './edit/ArsenalUnitEdit';
import MultiColorProgressBar from '@Builder/myArsenal/army/utils/multi-color.progress-bar';

export interface IarsenalUnit {
  unit: ArsenalUnitView;
}

const ArsenalUnitRow: React.FC<arsenalUnitProps> = ({ arsenalUnit, toDelete }) => {
  return (
    <UnitRow className="army_list_unit_overview mt-1 ms-0 me-0 p-2">
      <div className="d-flex justify-content-between">
        <h3 className="text-center">{arsenalUnit.name}</h3>
        <a className="m-1 float-end" onClick={() => toDelete(arsenalUnit.id)}><i className="fa fa-trash fa-2x" /></a>
      </div>
      <MultiColorProgressBar readings={arsenalUnit.steps} showValues={false} showLegends={false} />
      <ArsenalUnitEdit unit={arsenalUnit} />
    </UnitRow>
  );
};

const mapStateToProps = (state: AppState, props: IarsenalUnit) => ({
  arsenalUnit: props.unit
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const arsenalUnitAction = container.get<ArsenalUnitAction>(TYPES.Actions.ArsenalUnitAction);
  return {
    toDelete: (id: string) => dispatch(arsenalUnitAction.delete({ id: id }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArsenalUnitRow);

type arsenalUnitProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
